module.exports = __webpack_public_path__ + "img/cover-solid.39e1ac77.svg";